// TreeView.js
import React from "react";
import TreeNode from "./treeNode";
import List from "@mui/material/List";
import { Divider } from "@mui/material";

const TreeView = (props) => {
  return (
    <div>
      {props.data
        .filter(
          (node) =>
            !(props.mode === "products" && node.id === "PROD_COMP_REF_PKG"),
        )
        .map((node, index) => (
          <div key={node.id}>
            <List key={node.id} style={{ paddingTop: 0, paddingBottom: 0 }}>
              <TreeNode
                key={node.id}
                node={node}
                level={0}
                setLeafNodes={props.setLeafNodes}
                {...props}
                index={index}
              />
            </List>
            {/* {index < props.data.length - 1 &&
                        <Divider variant='middle'/>
                    } */}
          </div>
        ))}
    </div>
  );
};

export default TreeView;
